<template>
  <div class="common-title">
    <div class="common-title_item">
      <div @click="goBack">
        <img :src="backImg" alt class="common-title_back" />
      </div>
    </div>
    <div class="common-title_item common-title_item_center">
      <slot name="menu-name">
        <div class="common-title_name">{{ $route.meta.title }}</div>
      </slot>
    </div>
    <!-- <div class="common-title_item common-title_menu">
      <div @click="showMenu" v-if="showmenu">目录</div>
      <div class="myorder_btn" v-if="showOrder" @click="toMyOrder">我的订单</div>
      <div class="myorder_btn" v-if="showSign" @click="toMySign">签到</div>
    </div> -->
  </div>
</template>
<script>
import backImg from "@/assets/back.png";
export default {
  data() {
    this.backImg = backImg;
    this.open = open;
    return {
      show: false,
      showmenu: true,
      showOrder: false,
      showSign: false
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    showMenu() {
      this.show = !this.show;
      this.$emit("showMenu", this.show);
    },
    toMyOrder() {
      this.$router.push("/myorder");
    },
    toMySign() {
      this.$router.push({ path: "/activity/sign" });
    }
  },
  mounted() {
    if (this.$route.name == "serve") {
      this.showOrder = true;
      this.showmenu = false;
      this.showSign = false;
    } else if (this.$route.name == "activity") {
      this.showmenu = false;
      this.showSign = true;
      this.showOrder = false;
    } else {
      this.showmenu = true;
      this.showSign = false;
      this.showOrder = false;
    }
  },
  watch: {
    $route() {
      if (this.$route.name == "serve") {
        this.showOrder = true;
        this.showmenu = false;
        this.showSign = false;
      } else if (this.$route.name == "activity") {
        this.showmenu = false;
        this.showSign = true;
        this.showOrder = false;
      } else {
        this.showmenu = true;
        this.showSign = false;
        this.showOrder = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.common-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}
.common-title {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  height: 40px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #ffff;
  overflow: hidden;
  color: @menu-font-color;
  font-size: @m-font-size;
  &_item {
  }
  &_item_center {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
  }
  &_name {
    font-size: @m-font-size;
    text-align: center;
    font-weight:500;
  }
  &_menu {
    text-align: right;
  }
  .myorder_btn {
    display: inline-block;
    font-size: @xs-font-size;
    color: @white;
    text-align: center;
    width: 68px;
    height: 26px;
    line-height: 26px;
    background: linear-gradient(
      -70deg,
      rgba(250, 131, 125, 1),
      rgba(240, 91, 77, 1)
    );
    border-radius: 14px;
  }
  &_img {
    height: 26px;
  }
  &_back {
    width: 8px;
    height: 14px;
  }
}
</style>